module.exports = __webpack_public_path__ + "static/democratise@2x-5eaf86a6f5540881918502bbef6e08b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/financial-services/democratise@2x.jpg
// module id = 2630
// module chunks = 47877783677342